import AComponent from './slider-control.vue'
export default AComponent
